// Mock data for delivery rates - this can be used for testing when the backend is not ready
export const mockDeliveryRates = {
  baseRate: 0,
  freeDeliveryDistance: 2, // 0-2 km free
  chargePer100Meters: 0.50, // After 2km, charge 0.50 GHS per 100 meters
  currency: 'GHS' // Ghana Cedi
};

export const mockDeliveryZones = [
  {
    id: 1,
    name: 'Central Accra',
    baseRate: 0,
    freeDeliveryDistance: 2,
    chargePer100Meters: 0.50,
    isActive: true
  },
  {
    id: 2,
    name: 'East Legon',
    baseRate: 0,
    freeDeliveryDistance: 1.5,
    chargePer100Meters: 0.75,
    isActive: true
  },
  {
    id: 3,
    name: 'Tema',
    baseRate: 5,
    freeDeliveryDistance: 0,
    chargePer100Meters: 1.00,
    isActive: true
  }
];

// Helper function to calculate delivery cost
export const calculateDeliveryCost = (distance, rates = mockDeliveryRates) => {
  if (distance <= rates.freeDeliveryDistance) {
    return rates.baseRate;
  }
  
  const extraDistance = distance - rates.freeDeliveryDistance;
  const extraDistanceIn100M = Math.ceil(extraDistance * 10); // Convert km to 100m units
  return rates.baseRate + (extraDistanceIn100M * rates.chargePer100Meters);
};
